module.exports = __webpack_public_path__ + "img/dumbartons_scotts.e235787c.jpg";